import createCrudService from '@core/api/create-crud-service';
import { request } from '@src/core/api/request';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import { showToast } from '@src/shared/utils/helpers/show-toast';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@src/core/api/query-client';

import type { TBaseQuery } from '@src/shared/types/base-query';
import type { TRule } from '@src/shared/types/rule';

export type TRuleQuery = {
  created_by?: string;
  program?: string | number;
  stage?: string | number;
  type?: TRule['type'][];
  exclude_type?: TRule['type'][];
} & TBaseQuery;

export type TRulePayload = {
  name: string;
  type: TRule['type'];
  stage: number | string;
  program: number | string;

  choices?: string[];
  achieving_criterion?: string;
  is_required?: boolean;
  is_crm_only?: boolean;
  metadata?: string;
  description?: string;
  program_document?: number;
  question?: number;
  flight_type?: string;
};

const ruleApi = {
  ...createCrudService<TRule, TRuleQuery, TRulePayload>({
    queryKey: [QUERY_KEYS.getRules],
    url: `rules`,
    factory: {
      fetch: {
        requestOptions: (params?: Partial<TRuleQuery>) => ({
          params: {
            ...params,
            o: ['order'],
            page_size: 100,
          },
        }),
      },
    },
  }),

  useDuplicate: () => {
    return useMutation({
      mutationFn: ({ id }: { id: string | number }) =>
        request({
          url: `rules/${id}/duplicate/`,
          method: 'POST',
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[0] === QUERY_KEYS.getRules,
        });
        showToast({
          title: 'Duplicate Success',
          description: 'Rule has been duplicated successfully',
          variant: 'success',
        });
      },
    });
  },
};

export default ruleApi;
